/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SupplierDeliveryImportResponse interface.
 */
export function instanceOfSupplierDeliveryImportResponse(value) {
    return true;
}
export function SupplierDeliveryImportResponseFromJSON(json) {
    return SupplierDeliveryImportResponseFromJSONTyped(json, false);
}
export function SupplierDeliveryImportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'received': json['received'] == null ? undefined : json['received'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'notFound': json['notFound'] == null ? undefined : json['notFound'],
        'ignored': json['ignored'] == null ? undefined : json['ignored'],
    };
}
export function SupplierDeliveryImportResponseToJSON(json) {
    return SupplierDeliveryImportResponseToJSONTyped(json, false);
}
export function SupplierDeliveryImportResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'received': value['received'],
        'updated': value['updated'],
        'notFound': value['notFound'],
        'ignored': value['ignored'],
    };
}
